// extracted by mini-css-extract-plugin
module.exports = {"_kesselVerteilungColumn":"TourenplanTable__kesselVerteilungColumn__1eGD0"};